import * as React from "react";
import styles from "../styles/pages/informations.module.scss";
import MetaHeader from "../components/meta-header/meta-header";
// import { observable } from "mobx"
import { HeaderNewComponent } from "../new-components/header/Header";
import FooterNewComponent from "../new-components/footer/Footer";
import { useTranslation } from "next-i18next";
import nextI18NextConfig from "../next-i18next.config.js";
import KeysNewComponent from "../new-components/home/Keys/Keys";
import { trackPage } from "../api/analytics";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
function AboutScreen(props) {
  const { t, i18n } = useTranslation("informations");
  React.useEffect(() => {
    trackPage("About", {
      store: props.store,
      lang: props.lang,
      language: props.language,
      i18N: i18n.language,
    });
  }, [i18n.language, props.lang, props.language, props.store]);

  function getDescription() {
    return props.store === "us" ? getText(1) : getText();
  }
  function getTitle() {
    return t("about_title");
  }

  function getText(index?: number) {
    if (typeof index === "number") {
      return t("about_" + index);
    }
    return t("about");
  }

  function getIcon() {
    return "Choose-4-Life";
  }

  return (
    <div className={styles.informations}>
      <MetaHeader description={getDescription()} title={getTitle()} />
      <HeaderNewComponent
        disableScroll={true}
        store={props.store}
        language={i18n.language}
      />
      {(i18n.language === "fr" && props.store !== "us") ||
      props.store === "fr" ||
      (props.lang === "fr" && props.store !== "us") ? (
        <div className="container">
          <div className={`${styles.container} col-8 col-sm-12`}>
            <img
              src={`https://public.choose.app/website/new/images/${getIcon()}.png`}
              srcSet={`https://public.choose.app/website/new/images/${getIcon()}@2x.png 2x,https://public.choose.app/website/new/images/${getIcon()}@3x.png 3x`}
            />
            <h2 dangerouslySetInnerHTML={{ __html: getTitle() }} />
            <p dangerouslySetInnerHTML={{ __html: getText() }} />
          </div>
          <hr className={styles.hr} />
        </div>
      ) : (
        <div className="container">
          <div className={`${styles.container} col-8 col-sm-12`}>
            <img
              src={`https://public.choose.app/website/new/images/${getIcon()}.png`}
              srcSet={`https://public.choose.app/website/new/images/${getIcon()}@2x.png 2x,https://public.choose.app/website/new/images/${getIcon()}@3x.png 3x`}
            />
            <h2 dangerouslySetInnerHTML={{ __html: getTitle() }} />
            <p dangerouslySetInnerHTML={{ __html: getText(1) }} />
            <img
              src={`https://public.choose.app/website/new/images/Founders_NYC.png`}
              srcSet={`https://public.choose.app/website/new/images/Founders_NYC@2x.png 2x,https://public.choose.app/website/new/images/Founders_NYC@3x.png 3x`}
            />
            <p dangerouslySetInnerHTML={{ __html: getText(2) }} />
            <img
              src={`https://public.choose.app/website/new/images/Paris_Team.png`}
              srcSet={`https://public.choose.app/website/new/images/Paris_Team@2x.png 2x,https://public.choose.app/website/new/images/Paris_Team@3x.png 3x`}
            />
            <p dangerouslySetInnerHTML={{ __html: getText(3) }} />
            <p
              dangerouslySetInnerHTML={{ __html: getText(4) }}
              className={`${styles.bold}`}
            />
            <div className={`${styles.contact} col-6 col-sm-12 col-md-12`}>
              <p>
                <img
                  src={`https://public.choose.app/website/new/images/Flag-US.svg`}
                />
                You are located in the USA:
              </p>
              <hr />
              <ul>
                <li>
                  <img
                    src={`https://public.choose.app/website/new/images/Mail.png`}
                    srcSet={`https://public.choose.app/website/new/images/Mail@2x.png 2x,https://public.choose.app/website/new/images/Mail@3x.png 3x`}
                  />
                  <a href="mailto:vincent.c@appchoose.io">
                    vincent.c@appchoose.io
                  </a>
                </li>
                <li>
                  <img
                    src={`https://public.choose.app/website/new/images/Phone.png`}
                    srcSet={`https://public.choose.app/website/new/images/Phone@2x.png 2x,https://public.choose.app/website/new/images/Phone@3x.png 3x`}
                  />
                  +1(510)-504-4957
                </li>
                <img
                  className={`${styles.contactImage}`}
                  src={`https://public.choose.app/website/new/images/Contact-US.png`}
                  srcSet={`https://public.choose.app/website/new/images/Contact-US@2x.png 2x,https://public.choose.app/website/new/images/Contact-US@3x.png 3x`}
                />
              </ul>
            </div>
            <div className={`${styles.contact} col-6 col-sm-12 col-md-12`}>
              <p>
                <img
                  src={`https://public.choose.app/website/new/images/Flag-UE.svg`}
                />
                You are located in Europe:
              </p>
              <hr />
              <ul>
                <li>
                  <img
                    src={`https://public.choose.app/website/new/images/Mail.png`}
                    srcSet={`https://public.choose.app/website/new/images/Mail@2x.png 2x,https://public.choose.app/website/new/images/Mail@3x.png 3x`}
                  />
                  <a href="mailto:thyfaine.v@appchoose.io">
                    thyfaine.v@appchoose.io
                  </a>
                </li>

                <img
                  className={`${styles.contactImage}`}
                  src={`https://public.choose.app/website/new/images/Contact-UE.png`}
                  srcSet={`https://public.choose.app/website/new/images/Contact-UE@2x.png 2x,https://public.choose.app/website/new/images/Contact-UE@3x.png 3x`}
                />
              </ul>
            </div>
          </div>
          <hr className={styles.hr} />
        </div>
      )}
      <KeysNewComponent />
      <FooterNewComponent store={props.store} />
    </div>
  );
}
export const getServerSideProps = async (props) => {
  return {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "informations"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  };
};

export default AboutScreen;
